export default {
  currentIcon () {
    return this.focused ? 'chevron-up' : 'chevron-down'
  },
  itemsComputed () {
    let items = this.items

    if (typeof this.items === 'string') {
      items = JSON.parse(this.items)
    }

    return this.filteredBySearchItems(items)
  },
  inputValue () {
    if (this.$scopedSlots.selection && this.getSearchData() === '') return ''
    if (this.getSearchData() !== '') return this.getSearchData()
    return this.getItemText(this.selectedItem) || this.currentItemValue
  },
  currentItemValue () {
    return this.getItemValue(this.selectedItem)
  },
  showSelectionSlot () {
    return this.$scopedSlots.selection && this.selectedItem && !this.getSearchData()
  },
  inputForTextStyles () {
    let styles = {}

    if (this.inputElCustomAttributes && this.inputElCustomAttributes.style) {
      styles = {
        ...styles,
        ...this.inputElCustomAttributes.style
      }
    }

    return styles
  },
  hasMenu () {
    return this.wishShowMenu && !this.loading
  },
  hasError () {
    return !!this.errorMessage
  },
  isMobile () {
    if (process.server) return false
    return window.innerWidth <= 900 && window.innerHeight <= 900
  },
  menuDynamicStyles () {
    const input = this.$refs['IZ-select__input']
    const obj = {
      width: input.offsetWidth + 'px',
      left: input.offsetLeft + 'px',
      'pointer-events': this.hasMenu ? 'auto' : 'none'
    }

    if (this.disableSearch) {
      obj.top = input.offsetTop + 'px'
    }

    if (this.$el.offsetParent.className === 'modal-container') {
      obj.position = 'fixed'
    }

    return obj
  },
  selectedItemIndex () {
    for (let itemKey in this.itemsComputed) {
      if (this.selectedItem === this.itemsComputed[itemKey] && this.itemsComputed.hasOwnProperty(itemKey)) {
        return itemKey
      }
    }

    return null
  }
}
